import { render, staticRenderFns } from "./TheBody.vue?vue&type=template&id=56feee64&"
import script from "./TheBody.vue?vue&type=script&lang=js&"
export * from "./TheBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports